import React, { useEffect } from 'react';
import AntipodeMap from './AntipodeMap';
import LocationInfo from './LocationInfo';
import '../App.css';

function App() {
  useEffect(() => {
    const checkDevTools = (e) => {
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
        alert('개발자 도구는 사용할 수 없습니다.');
        window.location.reload();
      }
    };

    window.addEventListener('keydown', checkDevTools);

    return () => {
      window.removeEventListener('keydown', checkDevTools);
    };
  }, []);

  return (
      <div className="App">
        <h2 style={{ textAlign: 'center' }}>당신의 반대편 찾기</h2>
        <h5>Made by 규성</h5>
        <LocationInfo />
        <AntipodeMap />
      </div>
  );
}

export default App;
